module.exports = __webpack_public_path__ + "static/media/service-1.ed100fe5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service-1.gif
// module id = 202
// module chunks = 0